<template>
  <div class="smtpServers">
    <div class="row pt-3 l-m-b-20 blocks">
      <div class="d-flex align-items-center title-search col-9 pl-0">
        <h1 class="w-25">SMTP servers</h1>
        <div class="input-group search">
          <button type="button" class="btn input-group-btn" @click="clearSearch">
            <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
          </button>
          <input class="form-control search-input" type="text" v-model="q" @keyup="searchText($event)"
                 placeholder="Search"
          />
        </div>
      </div>
      <div class="col-3 text-right pr-0">
        <button class="btn btn-primary" type="button" :disabled="!companies" @click="showCreateModal = true">
          ADD
        </button>
      </div>
      <div class="row mobile-hidden">
        <div class="col-12 d-flex align-items-center filters-field">
          <span class="pr-2">Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.company" class="filter-item btn btn-filter mr-1">
              <span class="mod-icon-filter" @click="removeFilter('company')" />
              Company: {{ companies.find(el => el.id === filters.company).name }}</span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
      </div>
    </div>
    <template v-if="!companies">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="blocks" v-if="servers && servers.length">
        <SmtpServersBlock
          v-for="(server, index) in servers"
          :key="index"
          :companies="companies"
          :server.sync="server"
          @editServer="editSmtpServer(server)"
        />
        <div class="row blocks">
          <div class="col-sm-6 mb-1 text-black-50 pl-0"
               v-if="meta.total"
          >
            Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
          </div>
          <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
        </div>
      </div>
      <div v-else>
        <div class="text-center">You don’t have any SMTP servers added. Click the button at the top to create and connect to your company.</div>
      </div>
    </template>

    <modal v-if="showCreateModal" @close="closeModal" size="modal-large">
      <div slot="header">
        <h4>Add new smtp server</h4>
      </div>
      <div slot="body">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="row mb-2">
                <div class="col-12 mb-3">
                  <div class="title-text">Company</div>
                  <div class="select-wrap h-auto">
                    <label class="m-label">Company</label>
                    <simple-select v-model="companyId"
                                   :options="filteredCompanies"
                                   placeholder="Select Company"
                    />
                  </div>
                  <error-field :errors="errors" field="company_id" />
                </div>

                <div class="col-12 mb-2">
                  <div class="title-text">Credentials</div>
                  <div class="select-wrap">
                    <label class="m-label">Host</label>
                    <input v-model="company.mail_host" class="form-control" type="text" autocomplete="nope" />
                  </div>

                  <error-field :errors="errors" field="mail_host" />
                </div>

                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Port</label>
                    <input v-model="company.mail_port" class="form-control" autocomplete="nope1" type="text" />
                  </div>
                  <error-field :errors="errors" field="mail_port" />
                </div>

                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Username</label>
                    <input v-model="company.mail_username" class="form-control" autocomplete="nope2" type="text" />
                  </div>
                  <error-field :errors="errors" field="mail_username" />
                </div>
                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Password</label>
                    <input v-model="company.mail_password" class="form-control" autocomplete="new-password" type="password" />
                  </div>
                  <error-field :errors="errors" field="mail_password" />
                </div>
                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Encryption</label>
                    <input v-model="company.mail_encryption" autocomplete="nope4" class="form-control" type="text" />
                  </div>
                  <error-field :errors="errors" field="mail_encryption" />
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 instructions-text">
              <p><b>Settings explained below are related to Gmail SMTP settings for your account.</b></p>

              <p><b>If you wish to send from your own SMTP server, please contact your administrator for details how to set it up.</b></p>

              1. On your google account, allow access to less secure apps here <a href="https://myaccount.google.com/lesssecureapps" target="_blank">https://myaccount.google.com/lesssecureapps</a> <br />

              2. Enable 2 step verification on your google account <br />

              3. Go to mod24 SMTP servers and create a new one <br />

              4. Select a company you wish to send emails from your gmail account <br />

              5. Use smtp.gmail.com as a host, port 465, encryption as SSL or port 587/STARTTLS <br />

              6. Username will be the email address you are using for this company. If you are using an alias for the company please enter that instead of your primary account email<br />

              7. Password that provides access should be generated on your google account: <br />

              <div class="pl-3">- On your google account go to Security > Signing in to Google > App passwords <br /></div>

              <div class="pl-3">- Add a new app password by choosing “Other” and generating it <br /></div>

              <div class="pl-3">- Copy the generated password so you can grant access on mod24 <br /></div>

              11. Create <br />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="container">
        <div class="row mb-2">
          <div class="col text-right">
            <button type="button" class="btn btn-primary" :disabled="companyId === null" @click="saveSmtpServer">
              Create
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- EDIT MODAL -->
    <modal v-if="editModal" @close="closeModal" size="modal-large">
      <div slot="header">
        <h4>Edit SMTP server </h4>
      </div>
      <div slot="body">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="row mb-2">
                <div class="col-12 mb-3">
                  <div class="title-text">Company</div>
                  <div class="select-wrap">
                    <label class="m-label">Company</label>
                    <input v-model="companyName" class="form-control" autocomplete="nope5" type="text" :disabled="true" />
                  </div>
                  <error-field :errors="errors" field="company_id" />
                </div>

                <div class="col-12 mb-2">
                  <div class="title-text">Credentials</div>
                  <div class="select-wrap">
                    <label class="m-label">Host</label>
                    <input v-model="editedSmtpServer.mail_host" class="form-control" type="text" autocomplete="nope6" />
                  </div>

                  <error-field :errors="errors" field="mail_host" />
                </div>

                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Port</label>
                    <input v-model="editedSmtpServer.mail_port" class="form-control" autocomplete="nope7" type="text" />
                  </div>
                  <error-field :errors="errors" field="mail_port" />
                </div>

                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Username</label>
                    <input v-model="editedSmtpServer.mail_username" class="form-control" autocomplete="nope8" type="text" />
                  </div>
                  <error-field :errors="errors" field="mail_username" />
                </div>
                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Password</label>
                    <input v-model="editedSmtpServer.mail_password" class="form-control" autocomplete="new-password" type="password" />
                  </div>
                  <error-field :errors="errors" field="mail_password" />
                </div>
                <div class="col-12 mb-2">
                  <div class="select-wrap">
                    <label class="m-label">Encryption</label>
                    <input v-model="editedSmtpServer.mail_encryption" autocomplete="nope9" class="form-control" type="text" />
                  </div>
                  <error-field :errors="errors" field="mail_encryption" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="container">
        <div class="row mb-2">
          <div class="col d-flex justify-content-between">
            <button type="button" class="btn btn-danger deleteBtn" @click="deleteSmtpServer">
              Delete
            </button>
            <button type="button" class="btn btn-primary" @click="updateSmtpServer">
              Save
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column justify-content-between">
          <div class="filters-container">
            <div @click="showFilters = !showFilters" class="pointer">
              <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
            </div>
            <div>
              <p>
                Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
              </p>
            </div>
            <div class="l-bg-white">
              <div class="row">
                <div class="col">
                  <div class="row filters">
                    <div class="col-12">
                      <div class="select-wrap">
                        <label>Company</label>
                        <simple-select v-model="filters.company"
                                       :options="companies"
                                       placeholder="Select Company"
                                       @input="search"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="filters.company"
              >
                Clear filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import Modal from '../../Modal';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';
import SmtpServersBlock from './SmtpServersBlock';
import Pagination from '../../Pagination';

export default {
  name: 'SmtpServers',
  components: {
    SmtpServersBlock,
    Modal,
    ErrorField,
    Pagination,
  },
  data: () => ({
    companyId: null,
    meta: null,
    company: {
      mail_host: '',
      mail_port: '',
      mail_username: '',
      mail_password: '',
      mail_encryption: '',
    },
    editedSmtpServer: {
      mail_host: '',
      mail_port: '',
      mail_username: '',
      mail_password: '',
      mail_encryption: '',
    },
    filters: {
      company: '',
    },
    companyName: '',
    q: '',
    timer: null,
    page: 1,
    servers: null,
    showFilters: false,
    showCreateModal: false,
    editModal: false,
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
      filtersLoaded: state => state.guard.filtersLoaded,
    }),
    filteredCompanies() {
      return this.companies.filter(
        company => !this.servers.map(d => d.company_id).includes(company.id),
      );
    },
  },
  mounted() {
    if (Object.keys(this.$route.query).length !== 0) {
      this.setFilters(this.$route.query);
    }
    this.filter();
  },
  methods: {
    setFilters(query) {
      this.filters = Object.assign(
        {
          company: query.company_id ? parseInt(query.company_id, 10) : '',
        },
        {},
      );
      this.page = query.page;
      this.q = query.q.toString();
    },
    deleteSmtpServer() {
      this.editModal = false;
      this.$swal({
        title: 'Are you sure?',
        text: `By removing SMTP server for ${
          this.editedSmtpServer.mail_username
        }, you will no longer send emails with ${this.companyName}.`,
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        customClass: {
          actions: 'swall-custom-action',
        },
      }).then(result => {
        if (result.value)
          axios
            .delete(
              `/companies/${this.editedSmtpServer.company_id}/smtp-servers/${
                this.editedSmtpServer.id
              }`,
            )
            .then(() => {
              this.closeModal();
              this.getServers();
            })
            .catch(err => this.errors.record(err.response.data.error));
      });
    },
    editSmtpServer(server) {
      this.editedSmtpServer = server;
      this.editModal = true;
      // eslint-disable-next-line no-restricted-syntax
      for (const company of this.companies) {
        if (company.id === server.company_id) {
          this.companyName = company.name;
        }
      }
    },
    updateSmtpServer() {
      axios
        .put(
          `/companies/${this.editedSmtpServer.company_id}/smtp-servers/${this.editedSmtpServer.id}`,
          { ...this.editedSmtpServer },
        )
        .then(() => {
          this.closeModal();
          this.getServers();
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    saveSmtpServer() {
      axios
        .post(`/companies/${this.companyId}/smtp-servers`, { ...this.company })
        .then(() => {
          this.closeModal();
          this.getServers();
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getServers(pageNum) {
      if (pageNum) {
        axios
          .get(`/companies/smtp-servers?page=${pageNum}`)
          .then(res => {
            this.meta = res.data.meta;
            this.servers = res.data.data;
          })
          .catch(err => this.errors.record(err.response.data.error));
      } else {
        axios
          .get('/companies/smtp-servers')
          .then(res => {
            this.meta = res.data.meta;
            this.servers = res.data.data;
          })
          .catch(err => this.errors.record(err.response.data.error));
      }
    },
    changePage(pageNum) {
      this.getServers(pageNum);
    },
    closeModal() {
      this.showCreateModal = false;
      this.company.mail_host = '';
      this.company.mail_port = '';
      this.company.mail_username = '';
      this.company.mail_password = '';
      this.company.mail_encryption = '';
      this.companyId = null;
      this.editModal = false;
    },
    getSmtpServersFiltered(query) {
      axios
        .get(`/companies/smtp-servers?${query}`)
        .then(res => {
          this.meta = res.data.meta;
          this.servers = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    filter() {
      const query = `page=${this.page}&company_id=${this.filters.company}&q=${encodeURIComponent(
        this.q,
      )}`;
      this.getSmtpServersFiltered(query);
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/settings/smtp-servers?${query}`);
      } else {
        this.$router.push(`/settings/smtp-servers`);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          company: '',
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    removeFilter(model) {
      this.filters[model] = '';
      this.search();
    },
  },
};
</script>
<style scoped>
.instructions-text,
.instructions-text a {
  font-size: 12px;
}
.title-text {
  font-size: 12px;
  font-weight: 600;
  padding-bottom: 8px;
  text-transform: uppercase;
  color: #616161;
}
.deleteBtn {
  height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Mailing/SmtpServers.vue